import React from "react";
import recommendation from "../../../assets/images/recommendation.svg";
import chevronRight from "../../../assets/images/chevron-right.svg";
import { useNavigate } from "react-router-dom";
import useStore from "../../../store/useStore";
import { GENERAL_SPECIALITY_ID } from "../../../envConstants";

const Recommendation: React.FC = () => {
  const { doctorDetails } = useStore();

  const navigate = useNavigate();
  const navigateToAccount = () => {
    navigate("/account");
  };
  return !doctorDetails?.user?.speciality ||
    (doctorDetails?.user?.speciality &&
      doctorDetails?.user?.speciality === GENERAL_SPECIALITY_ID) ? (
    <section
      className="flex flex-col justify-center px-6 w-full"
      onClick={navigateToAccount}
    >
      <div className="flex overflow-hidden flex-col justify-center px-4 py-3 w-full bg-orange-50 rounded-3xl border border-amber-500 border-solid backdrop-blur-[20px]">
        <div className="flex gap-2 items-center w-full">
          <div className="flex flex-1 shrink gap-3 items-center self-stretch my-auto basis-0 min-w-[240px]">
            <img
              loading="lazy"
              src={recommendation}
              alt="Recommendation"
              className="object-contain shrink-0 self-stretch my-auto aspect-[0.94] w-[51px]"
            />
            <div className="flex flex-col flex-1 shrink self-stretch my-auto basis-0">
              <h3 className="text-base font-semibold text-gray-800 text-left">
                Recommendation
              </h3>
              <p className="mt-1 text-xs leading-5 text-gray-700 text-left">
                Complete your profile so <br /> that we can assist you better
              </p>
            </div>
          </div>
          <img
            loading="lazy"
            src={chevronRight}
            alt="Arrow"
            className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
          />
        </div>
      </div>
    </section>
  ) : (
    <></>
  );
};

export default Recommendation;
